<span class="date-selector">
	<input type="text" [ngModel]="dateInput" [attr.placeholder]="placeholder" (ngModelChange)="onChanged($event)"><i class="fa fa-calendar"></i>
</span>
